import axios from "axios";
const API = axios.create({baseURL:`${process.env.REACT_APP_BACKEND_URL}`,withCredentials: true});
API.defaults.headers.post["Content-Type"] = "application/json";
API.defaults.headers.common["Authorization"] = `${process.env.REACT_APP_API_KEY}`;
class AdminService {
    static login(data)
    {
        let url = `/api/admins/login`;
        return API.post(url,data);
    }
    static logOut()
    {
        let url = '/api/admins/logout';
        return API.get(url,{});
    }
    static uploadProduct(productData) {
        let url = '/api/admins/upload';
        return API.post(url,productData);
    }
    static deleteProduct(productId) {
        let url = '/api/admins/delete-product';
        return API.delete(url,{data:{productId}});
    }
    static updateProduct(product) {
        let url = '/api/admins/update-item';
        return API.patch(url,product);
    }
    static cancelOrder(orderId) {
        let url = '/api/admins/cancel-order';
        return API.patch(url,{orderId});
    }
    static getAllOrders() {
        let url = '/api/admins/orders';
        return API.get(url);
    }
    static getUserData()
    {
        let url = `/api/admins/me`;
        return API.get(url,{});
    }
    static getProducts(page)
    {
        let url = `/api/admins/items-list?page=${page}`;
        return API.get(url,{});
    }
    static dispatch(orderId,trackingId) {
        let url = `/api/admins/dispatch`;
        return API.patch(url,{orderId,trackingId});
    }
}
export default AdminService;